import PropTypes from 'prop-types';
import AccommodationCard from '~/js/components/accommodations/AccommodationCard';
import Modal from '~/js/components/global/Modal';
import FeatureTooltips from '~/js/components/accommodations/FeatureTooltips';
import ReactLoader from '~/js/components/global/ReactLoader';
import GoFetch from '~/js/modules/fetch-wrapper';

const { Component, Fragment } = React;
const fetch = new GoFetch();
const internals = {};

internals.roomDetailURI = {
  btc: '/resorts/turks-caicos/rooms/',
  bng: '/resorts/negril/rooms/',
  bbo: '/resorts/ocho-rios/rooms/'
};

export default class FamilySuites extends Component {
  static propTypes = {
    resortCode: PropTypes.string.isRequired,
    roomCodes: PropTypes.array.isRequired,
  };

  static defaultProps = {
    resortCode: '',
    roomCodes: []
  };

  constructor(props) {
    super(props);

    this.state = {
      isListView: window.innerWidth > 767,
      modalTitle: '',
      modalDetails: '',
      status: 'loading',
      accommodations: []
    };
  }

  componentDidMount = () => {
    const roomCategoryCodes = this.props.roomCodes.join(',');

    fetch.get(`/fetchRoomData/?roomCategoryCodes=${roomCategoryCodes}`)
      .then(response => {
        const { status = 'error', data = {} } = response;

        if (status === 'success' && data.roomData && data.roomData.length > 0) {

          this._updateRooms(response.data.roomData, this._updateStatus('success'));
        } else {

          this._updateStatus('error');
        }

        return 0;
      });

    window.addEventListener('resize', _globalUtils.debounce(() => {

      if (window.innerWidth < 768 && this.state.isListView) {
        this.setState({ isListView: false });
      } else if(window.innerWidth > 768) {
        window.$.magnificPopup.close();
      }
    }, 200));
  }

  _updateRooms = (accommodations, cb) => this.setState({ accommodations }, cb);

  _updateStatus = (status) => this.setState({ status });

  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _updateView = (isListView = false) => () => this.setState({ isListView });

  render() {
    const modalId = 'mdl-promotion';
    const { isListView } = this.state;
    const { status } = this.state;

    return (
      <div className="cards-container">
        {
          {
            error: (<span className="txt-center display-block">An error has ocurred, please refresh this page and try again</span>),
            loading: (<ReactLoader className="sk-loader-accommodation-level"/>),
            success: (<Fragment>
              <div className="row center-xs">
                <div className="xs-12 txt-left pr grid-select">
                  <div className="inline-block grid-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView() } className="change-view color-acacac">
                      <i className={`icon-grid-view ${ (!isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">GRID VIEW</span>
                    </div>
                  </div>
                  <div className="inline-block list-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView(true) } className="change-view color-acacac">
                      <i className={`icon-list-view ${ (isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">LIST VIEW</span>
                    </div>
                  </div>
                </div>
                <div className="tooltip_templates hide">
                  <FeatureTooltips />
                </div>
                {
                  this.state.accommodations.map(
                    (room) => (<AccommodationCard
                      key={room.code}
                      roomInformation={room}
                      isListView={this.state.isListView}
                      modalId={modalId}
                      updateModal={this._updateModal}
                      villageCode={this.props.resortCode}
                      roomDetailURI={internals.roomDetailURI}
                    />))
                }
                <Modal id={modalId} title={this.state.modalTitle} content={this.state.modalDetails} />
              </div>
            </Fragment>)
          }[status]
        }
      </div>
    );
  }
}
